
const menuToggle = document.querySelector('.menu-toggle');
const mainNav = document.querySelector('.main-nav');
if (menuToggle && mainNav) {
  menuToggle.addEventListener('click', () => {
    const open = mainNav.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  });
  mainNav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    mainNav.classList.remove('open');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  }));
}
document.querySelectorAll('[data-year]').forEach(el => el.textContent = new Date().getFullYear());

// Pre-fill the Shopify-native quote form from inspiration buttons.
const quoteForm = document.querySelector('[data-quote-form]');
if (quoteForm) {
  const params = new URLSearchParams(location.search);
  const project = params.get('project');
  const idea = params.get('idea');
  const projectSelect = quoteForm.querySelector('[name="contact[Project type]"]');
  const details = quoteForm.querySelector('[name="contact[Project details]"]');
  if (project && projectSelect) {
    const option = [...projectSelect.options].find(o => o.value.toLowerCase() === project.toLowerCase() || o.text.toLowerCase() === project.toLowerCase());
    if (option) projectSelect.value = option.value;
  }
  if (idea && details && !details.value) details.value = `I'm interested in: ${idea}\n\nCustomization details:`;

  const copyButton = quoteForm.querySelector('[data-copy-request]');
  const status = quoteForm.querySelector('[data-copy-status]');
  if (copyButton) copyButton.addEventListener('click', async () => {
    const data = new FormData(quoteForm);
    const lines = [
      'Angeley Custom Co. custom project request', '',
      `Name: ${data.get('contact[name]') || ''}`,
      `Email: ${data.get('contact[email]') || ''}`,
      `Phone: ${data.get('contact[Phone]') || 'Not provided'}`,
      `Project Type: ${data.get('contact[Project type]') || 'Custom Project'}`,
      `Approx. Quantity: ${data.get('contact[Quantity]') || 'Not provided'}`,
      `Needed By: ${data.get('contact[Needed by]') || 'Not provided'}`,
      `Artwork Ready: ${data.get('contact[Artwork ready]') || 'No'}`, '',
      'Project Details:', data.get('contact[Project details]') || ''
    ];
    try {
      await navigator.clipboard.writeText(lines.join('\n'));
      if (status) { status.textContent='Project details copied.'; status.className='copy-status ok'; }
    } catch(e) {
      if (status) { status.textContent='Copy was blocked by the browser.'; status.className='copy-status error'; }
    }
  });
}

// Inspiration gallery filter.
const galleryButtons = document.querySelectorAll('[data-gallery-filter]');
const galleryItems = document.querySelectorAll('[data-gallery-item]');
if (galleryButtons.length && galleryItems.length) {
  galleryButtons.forEach(button => button.addEventListener('click', () => {
    const filter = button.dataset.galleryFilter;
    galleryButtons.forEach(btn => btn.classList.toggle('active', btn === button));
    galleryItems.forEach(item => item.hidden = filter !== 'all' && item.dataset.galleryItem !== filter);
  }));
}
